import { lazy, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import Hero from './components/Hero';
import Features from './components/Features';
import Pricing from './components/Pricing';
import FAQ from './components/FAQ';
import Footer from './components/Footer';
import StructuredData from './components/StructuredData';
import { usePageTracking } from './hooks/usePageTracking';
import { useScrollDepth } from './hooks/useScrollDepth';

const Privacy = lazy(() => import('./pages/Privacy'));
const Terms = lazy(() => import('./pages/Terms'));

function Landing() {
  useScrollDepth();

  return (
    <div className="min-h-screen bg-background text-foreground">
      <StructuredData />
      <Hero />
      <Features />
      <Pricing />
      <FAQ />
      <Footer />
    </div>
  );
}

export default function App() {
  usePageTracking();

  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route
        path="/privacy"
        element={
          <Suspense fallback={null}>
            <Privacy />
          </Suspense>
        }
      />
      <Route
        path="/terms"
        element={
          <Suspense fallback={null}>
            <Terms />
          </Suspense>
        }
      />
    </Routes>
  );
}
